import { render, staticRenderFns } from "./RELManutencaoHistorico.vue?vue&type=template&id=0ce91267&"
import script from "./RELManutencaoHistorico.vue?vue&type=script&lang=js&"
export * from "./RELManutencaoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./RELManutencaoHistorico.vue?vue&type=style&index=0&id=0ce91267&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports